module.exports = __webpack_public_path__ + "img/FE_A1_back_en.3513569f.png";